import React, { useEffect, useReducer, useState } from 'react';
import { connect } from 'react-redux';
import fetchAPI from '../../utils/fetchAPI';
import { useHistory } from 'react-router-dom';
import EndUserDashboardView from '../view/EndUserDashboardView';
import getTenant from '../../utils/getTenant';

const dashboardReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    default:
      return state;
  }
};

const initialReducerState = {
  formsData: []
};

const EndUserDashboardEngine = ({ assets, userProfile }) => {
  const tenant = getTenant();
  const WHITE_LIST_OF_TENANTS_FOR_TASKS = [
    'healthandsafety',
    'dev_gilan',
    'gilan_local',
    'baruchk',
    'ymaayan',
    'maryna'
  ];
  const history = useHistory();

  const [reducerState, dispatch] = useReducer(
    dashboardReducer,
    initialReducerState
  );
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [endUserTab, setEndUserTab] = useState('tasks');
  const [tasksCount, setTasksCount] = useState(false);

  const changeEndUserTab = (e, val) => {
    setEndUserTab(val);
  };

  useEffect(() => {
    let getSharedSubmissionsURL, getTasksCountURL, sharedPromise, tasksPromise;

    getSharedSubmissionsURL = `/forms/v1/eusubmissions?shared=full&mode=dashboard&query=[[{"what":"count","field":"*", "as": "count"}],[{"what":"","field":"'formId'","as":"formId"}],[{"groupOn":"'formId'"}]]`;
    sharedPromise = new Promise((resolve, reject) => {
      fetchAPI(getSharedSubmissionsURL).then(res => {
        if (res) {
          resolve(res.results);
        } else {
          reject(res);
        }
      });
    });
    getTasksCountURL = `/tasks/v1/eu/tasks`;
    tasksPromise = new Promise((resolve, reject) => {
      if (!WHITE_LIST_OF_TENANTS_FOR_TASKS.includes(tenant)) {
        resolve(0);
        return;
      }
      fetchAPI(getTasksCountURL).then(res => {
        const results = res?.results || [];
        resolve(results.length);
      });
    });
    Promise.all([sharedPromise, tasksPromise]).then(allResults => {
      let formIds, sharedRes, tasksRes, newFormData, i, oneFormData;
      newFormData = [];
      formIds = [];

      sharedRes = allResults[0];
      tasksRes = allResults[1];
      for (i = 0; i < sharedRes.length; i++) {
        if (formIds.indexOf(sharedRes[i].formId) === -1) {
          formIds.push(sharedRes[i].formId);
          oneFormData = sharedRes[i].formData;
          if (oneFormData) {
            oneFormData.id = sharedRes[i].formId;
            oneFormData.hasNoSubmissions = sharedRes[i].hasNoSubmissions;
            newFormData.push(oneFormData);
          }
        }
      }
      if (newFormData.length === 1) {
        history.push('/dashboard/' + newFormData[0].id + '/singleform');
        return;
      }
      newFormData = newFormData.sort((a, b) => {
        let titleA, titleB;
        if (a.archived && !b.archived) {
          return 1;
        } else if (b.archived && !a.archived) {
          return -1;
        }
        titleA = a.title.toLowerCase();
        titleB = b.title.toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });

      setTasksCount(tasksRes);
      if (!tasksRes) {
        setEndUserTab('forms');
      }
      setIsInitialLoading(false);
      dispatch({
        type: 'update',
        payload: {
          formsData: newFormData
        }
      });
    });
  }, []);

  const viewProps = {
    userProfile,
    reducerState,
    tasksCount,
    isInitialLoading,
    endUserTab,
    changeEndUserTab
  };

  return <EndUserDashboardView {...viewProps} />;
};

const mapStateToProps = (store, props) => ({
  formId: store.router.location.pathname.split(/^\/[^/]+\//)[1],
  userProfile: store.state.userProfile
});

export default connect(mapStateToProps)(EndUserDashboardEngine);
